import dateTime from "src/utils/dateTime";

const ACTION_PALETTE: { bg: string; color: string }[] = [
    { bg: '#F4F3FF', color: '#5925DC' },
    { bg: '#FEF6EE', color: '#B93815' },
    { bg: '#E7F6F5', color: '#0A756F' },
    { bg: '#F8F9FC', color: '#363F72' },
    { bg: '#F0F9FF', color: '#026AA2' },
    { bg: '#FDF2FA', color: '#C11574' },
    { bg: '#ECFDF3', color: '#027A48' },
]

function hashString(value: string): number {
    let hash = 0
    for (let i = 0; i < value.length; i += 1) {
        hash = (hash * 31 + value.charCodeAt(i)) >>> 0
    }
    return hash
}

export function actionPillColors(action: string): { bg: string; color: string } {
    if (!action) return { bg: '#F2F4F7', color: '#667085' }
    return ACTION_PALETTE[hashString(action) % ACTION_PALETTE.length]
}

// "2026-01-07T08:58:00Z" (UTC) -> "7 Jan 2026, 08:58 AM" (browser-local)
export function formatAuditTimestamp(iso: string | null | undefined): string {
    if (!iso) return '—'
    const date = dateTime.parseUtc(iso)
    if (!date) return iso

    const datePart = date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
    const timePart = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
    return `${datePart}, ${timePart}`
}

export function parseAuditData(raw: string | null | undefined): Record<string, unknown> | null {
    if (!raw) return null
    try {
        const parsed = JSON.parse(raw)
        return typeof parsed === 'object' && parsed !== null ? parsed : null
    } catch {
        return null
    }
}

export function formatFieldLabel(key: string): string {
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, (c) => c.toUpperCase()).trim()
}

export function formatFieldValue(value: unknown): string {
    if (value === null || value === undefined || value === '') return '—'
    if (typeof value === 'boolean') return value ? 'Yes' : 'No'
    return String(value)
}